import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const DESCRIPTION =
    '2026年11月3日，美国中期选举举行。根据美国选举制度，本次选举不选举总统，将改选众议院全部席位、部分参议院席位以及多个州州长等职位，目前各地选票统计工作正在推进中。';

const BANNER = 'https://x0.ifengimg.com/ucms/2026_44/77D656037EAE1ECCBEFC5F1C66571851A60CCD28_size198_w750_h440.png';

const pad2 = value => String(value).padStart(2, '0');

const Banner = ({ description = DESCRIPTION, isPc }) => {
    const now = new Date();
    const month = pad2(now.getMonth() + 1);
    const day = pad2(now.getDate());

    return (
        <section className={`${styles.wrap} ${(window.ground || isPc) ? '' : styles.marginTop}`}>
            <div className={styles.banner}>
                <img className={styles.image} src={BANNER} alt="" crossOrigin="anonymous" />
                <div className={styles.date}>
                    {month.split('').map((digit, index) => (
                        <span className={styles.monthDigit} key={`month-${index}`}>
                            {digit}
                        </span>
                    ))}
                    <span className={styles.unit}>月</span>
                    {day.split('').map((digit, index) => (
                        <span className={styles.dayDigit} key={`day-${index}`}>
                            {digit}
                        </span>
                    ))}
                    <span className={styles.unit}>日</span>
                </div>
            </div>
            {description && <p className={styles.desc}>{description || DESCRIPTION}</p>}
        </section>
    );
};

Banner.propTypes = {
    description: PropTypes.string,
    isPc: PropTypes.bool
};

export default errorBoundary(Banner);
